import { Dialog } from "@headlessui/react";
import Button from "../../components/button/Button";
import {Modal, ModalTitle} from "../../components/modal/Modal";
import { ModalProp } from "../../components/modal/Modal";
import { MagnifyingGlassIcon } from "@heroicons/react/24/solid";
import TableList, { GridCol, GridRow } from "../../components/table/TableList";

type GroupSelectModalProps = {
  onClickGroupSubmit: () => void;
  columns: GridCol[];
  rowList: GridRow[];
  onSearch: (e: any) => void;
};

export const GroupSelectModal = ({
  open,
  toggle,
  closeOnClickOutside,
  onClickGroupSubmit,
  onSearch,
  columns,
  rowList,
}: ModalProp & GroupSelectModalProps) => {

  return (
    <Modal
      open={open}
      toggle={toggle}
      closeOnClickOutside={closeOnClickOutside}
    >
      <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:w-full max-w-screen-md ">
        <div className="px-2 -mt-8 pb-4 sm:p-4">
          <ModalTitle mainTitle="配信先グループ選択" subTitle="配信するグループを選択してください"/>
          <div className="mt-4 flex space-x-2 items-center">
            <div className="relative flex focus-within:z-10">
              <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                <MagnifyingGlassIcon
                  className="h-5 w-5 text-gray-400"
                  aria-hidden="true"
                />
              </div>
              <input
                onChange={onSearch}
                className="w-64 rounded-md pl-10 focus:border-indigo-500 focus:ring-indigo-500 border px-3 py-2 border-gray-300 shadow-sm sm:text-sm "
                placeholder="名前で検索"
              />
            </div>
            <div>
              ※2文字以上の入力で検索できます。
            </div>
          </div>
        </div>
        <div className={"max-h-[calc(100vh_-_20rem)] overflow-auto px-3 pb-4 pt-1"}>
          <TableList
            gridCol={columns}
            gridRow={rowList}
            sort={false}
            footer={false}
          />
        </div>
        <div className="p-4 bg-gray-100">
          <div className="flex justify-end">
            <Button
              className="mx-2 mt-1 w-[132px]"
              outline
              onClick={toggle}
              children={'キャンセル'}
            />
            <Button
              className="mt-1 w-[132px]"
              children={'登録'}
              onClick={onClickGroupSubmit}
            />
          </div>
        </div>
      </Dialog.Panel>
    </Modal>
  );
};
